export default class VideoViewportPlay {
    constructor(options = {}) {
        this.options = {
            selector: '[data-video-viewport-play]',
            ...options
        };

        this.elements = [];
        this.observer = null;
        
        this.init();
    }

    init() {
        const elements = document.querySelectorAll(this.options.selector);

        if (elements.length === 0) return;

        // Create Intersection Observer
        // rootMargin: '0% 0% -10% 0%' means the intersection area starts at 10% from the top
        // This triggers when the element's top edge reaches 10% down the viewport
        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const video = entry.target.querySelector('video');
                        if (video && video.paused) {
                            video.play().catch(error => {
                                console.warn('Video play failed:', error);
                            });
                        }
                    }
                });
            },
            {
                rootMargin: '0% 0% -50% 0%',
                threshold: 0
            }
        );

        // Observe each element
        elements.forEach(element => {
            const video = element.querySelector('video');
            
            if (!video) {
                console.warn('No video element found in', element);
                return;
            }

            // Ensure video is paused initially (remove autoplay if present)
            video.pause();
            video.currentTime = 0;

            this.observer.observe(element);
            
            this.elements.push({
                element,
                video
            });
        });
    }

    destroy() {
        if (this.observer) {
            this.elements.forEach(({ element }) => {
                this.observer.unobserve(element);
            });
            this.observer.disconnect();
            this.observer = null;
        }

        // Pause all videos
        this.elements.forEach(({ video }) => {
            if (video) {
                video.pause();
            }
        });

        this.elements = [];
    }
}
